import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik';
import React, { Fragment } from 'react'
import { useRef } from 'react';
import { useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import estilos from '../Tabs/TabsInspeccionarComponent.module.css'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import { useContext } from 'react';
import InspectorEnCampoContext from '../../Context/InspectorEnCampoContext';
import { getTipoEquipoByIdArea } from '../../../../redux/DucksUnidadInspeccion/TipoEquipoDuck';
import { getElementoSeccionByIdArea } from '../../../../redux/DucksUnidadInspeccion/ElementoSeccionDuck';
import { getProcesoByIdArea } from '../../../../redux/DucksUnidadInspeccion/ProcesosDuck';
import { insertFi25Procesos } from '../../../../redux/DucksUnidadInspeccion/Fi25anexoProcesosDuck';
import { insertEquipoHistorial } from '../../../../redux/DucksUnidadInspeccion/Fi25anexoEquipoHistorial';
import { insertDataElementoClienteHistorial } from '../../../../redux/DucksUnidadInspeccion/DataElementoClienteHistorialDuck';
import { getanexoByIdInforme } from '../../../../redux/DucksUnidadInspeccion/Fi25anexoDuck';
import { insertSuperficie } from '../../../../redux/DucksUnidadInspeccion/SuperficieDuck';
import { ReactNotifications } from 'react-notifications-component'
import { Store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import Collapsible from 'react-collapsible';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1300,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function ProcesosYEquipo(props) {

    const dispatch = useDispatch();

    const { areaEnvasadoContext, setContextAreaEnvasado, envasadoOtrosContext, setContextEnvasadoOtros, productoGranelContext, setContextProductoGranel, productoTerminadoContext, setContextProductoTerminado, almacenMaduracionContext, setContextAlmacenMaduracion } = useContext(InspectorEnCampoContext);

    const [isContext, setIsContext] = React.useState(false);

    const tipoequipo = useSelector(store => store.ElementoSeccion.ElementoSeccion);
    const procesos = useSelector(store => store.Procesos.Proceso);
    const verdaderaInstalacion = props.verdaderaInstalacion;
    let todo = props.detalles;
    const idinforme = props.idinforme;
    const otros = props.otros;
    const idseccion = props.idseccion;
    const idanexo = useSelector(store => store.anexo.anexo);
    const instalacion = props.instalacion - 1;
    const idtipoinstalacion = todo?.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.instalacionescliente[0]?.tipoinstalacion?.idtipoinstalacion;
    const [equipoArea, setEquipo] = React.useState([]);
    const [procesosArea, setProcesosArea] = React.useState([]);

    const [initialValues, setInitialValues] = React.useState({
        equipo: equipoArea,
        procesosArea: procesosArea,
        largo: 0,
        ancho: 0,
        area: 0
    })

    const [informacionFormikModal, setInformacionFormikModal] = React.useState(
        {
            tipo: '',
            cantidad: '',
            capacidad: '',
            descripcion: '',
            condicion: '',
            largo: '',
            ancho: '',
            area: ''
        }
    );

    const [openModalNuevoEquipo, setOpenModalNuevoEquipo] = React.useState(false);

    const [editarEquipo, setEditarEquipo] = React.useState(true);

    const [seccionesAreaEnvasado, setSeccionesAreaEnvasado] = React.useState([]);

    useEffect(() => {
        if (verdaderaInstalacion.idtipoanexo === 2) {
            if (otros === true) {
                if (envasadoOtrosContext != null) {
                    setEquipo(envasadoOtrosContext.equipo)
                } else {
                    setEquipo([])
                }
            } else if (areaEnvasadoContext != null) {
                setEquipo(areaEnvasadoContext.equipo)
            }

            if (areaEnvasadoContext === null) {
                setContextAreaEnvasado({
                    equipo: equipoArea
                })
            }
        }
    }, [otros])

    useEffect(() => {

        if (verdaderaInstalacion.idtipoanexo === 3) {
            dispatch(getElementoSeccionByIdArea(idseccion))
        }
        if (verdaderaInstalacion.idtipoanexo === 3) {
            let equipoAux = []
            if (idseccion === 5) {
                if (productoGranelContext != null) {
                    setEquipo(productoGranelContext.equipo)
                    setIsContext(true)
                } else {
                    todo.anexocliente[instalacion].dataelementocliente.map((equipo) => {
                        if (equipo.idseccion === 5) {
                            let capacidad = parseInt(equipo.descripcion)
                            if (isNaN(capacidad)) {
                                equipoAux.push({
                                    cantidad: equipo.cantidad,
                                    descripcion: equipo.descripcion,
                                    elemento: {
                                        idelemento: equipo.elemento.idelemento,
                                        nombreelemento: equipo.elemento.nombreelemento
                                    },
                                    idanexocliente: equipo.idanexocliente,
                                    iddataelementocliente: equipo.iddataelementocliente,
                                    idelemento: equipo.idelemento,
                                    idseccion: equipo.idseccion,
                                    otro: equipo.otro
                                })
                            } else {
                                equipoAux.push({
                                    cantidad: equipo.cantidad,
                                    descripcion: "",
                                    capacidad: equipo.descripcion,
                                    elemento: {
                                        idelemento: equipo.elemento.idelemento,
                                        nombreelemento: equipo.elemento.nombreelemento
                                    },
                                    idanexocliente: equipo.idanexocliente,
                                    iddataelementocliente: equipo.iddataelementocliente,
                                    idelemento: equipo.idelemento,
                                    idseccion: equipo.idseccion,
                                    otro: equipo.otro
                                })
                            }
                        }
                    })
                    setEquipo(equipoAux)
                }
            }

            if (idseccion === 11) {
                if (productoTerminadoContext != null) {
                    setEquipo(productoTerminadoContext.equipo)
                    setIsContext(true)
                } else {
                    todo.anexocliente[instalacion].dataelementocliente.map((equipo) => {
                        if (equipo.idseccion === 11) {
                            let capacidad = parseInt(equipo.descripcion)
                            if (isNaN(capacidad)) {
                                equipoAux.push({
                                    cantidad: equipo.cantidad,
                                    descripcion: equipo.descripcion,
                                    elemento: {
                                        idelemento: equipo.elemento.idelemento,
                                        nombreelemento: equipo.elemento.nombreelemento
                                    },
                                    idanexocliente: equipo.idanexocliente,
                                    iddataelementocliente: equipo.iddataelementocliente,
                                    idelemento: equipo.idelemento,
                                    idseccion: equipo.idseccion,
                                    otro: equipo.otro
                                })
                            } else {
                                equipoAux.push({
                                    cantidad: equipo.cantidad,
                                    descripcion: "",
                                    capacidad: equipo.descripcion,
                                    elemento: {
                                        idelemento: equipo.elemento.idelemento,
                                        nombreelemento: equipo.elemento.nombreelemento
                                    },
                                    idanexocliente: equipo.idanexocliente,
                                    iddataelementocliente: equipo.iddataelementocliente,
                                    idelemento: equipo.idelemento,
                                    idseccion: equipo.idseccion,
                                    otro: equipo.otro
                                })
                            }
                        }
                    })
                    setEquipo(equipoAux)
                }
            }

            if (idseccion === 12) {
                if (almacenMaduracionContext != null) {
                    setEquipo(almacenMaduracionContext.equipo)
                    setIsContext(true)
                } else {
                    todo.anexocliente[instalacion].dataelementocliente.map((equipo) => {
                        if (equipo.idseccion === 12 || equipo.idseccion === 13) {
                            let capacidad = parseInt(equipo.descripcion)
                            if (isNaN(capacidad)) {
                                equipoAux.push({
                                    cantidad: equipo.cantidad,
                                    descripcion: equipo.descripcion,
                                    elemento: {
                                        idelemento: equipo.elemento.idelemento,
                                        nombreelemento: equipo.elemento.nombreelemento
                                    },
                                    idanexocliente: equipo.idanexocliente,
                                    iddataelementocliente: equipo.iddataelementocliente,
                                    idelemento: equipo.idelemento,
                                    idseccion: equipo.idseccion,
                                    otro: equipo.otro
                                })
                            } else {
                                equipoAux.push({
                                    cantidad: equipo.cantidad,
                                    descripcion: "",
                                    capacidad: equipo.descripcion,
                                    elemento: {
                                        idelemento: equipo.elemento.idelemento,
                                        nombreelemento: equipo.elemento.nombreelemento
                                    },
                                    idanexocliente: equipo.idanexocliente,
                                    iddataelementocliente: equipo.iddataelementocliente,
                                    idelemento: equipo.idelemento,
                                    idseccion: equipo.idseccion,
                                    otro: equipo.otro
                                })
                            }
                        }
                    })
                    setEquipo(equipoAux)
                }
            }
        }

    }, [idseccion])

    useEffect(() => {
        if (verdaderaInstalacion.idtipoanexo === 2) {
            //dispatch(getTipoEquipoByIdArea(5))
            dispatch(getElementoSeccionByIdArea(6))
            dispatch(getProcesoByIdArea(26))

        } else if (verdaderaInstalacion.idtipoanexo === 3) {
            dispatch(getElementoSeccionByIdArea(idseccion))
        }
        // if (idinforme?.idfi_25_informecumplimientonom) {
        //     dispatch(getanexoByIdInforme(idinforme.idfi_25_informecumplimientonom)) //informe
        // }

        if (verdaderaInstalacion.idtipoanexo === 2) {
            if (otros != true) {
                if (areaEnvasadoContext !== null) {
                    setEquipo(areaEnvasadoContext.equipo)
                    setIsContext(true)
                } else {
                    todo.anexocliente[instalacion].dataelementocliente.map((equipo) => {
                        let capacidad = parseInt(equipo.descripcion)
                        if (isNaN(capacidad)) {
                            equipoArea.push({
                                cantidad: equipo.cantidad,
                                descripcion: equipo.descripcion,
                                elemento: {
                                    idelemento: equipo.elemento.idelemento,
                                    nombreelemento: equipo.elemento.nombreelemento
                                },
                                idanexocliente: equipo.idanexocliente,
                                iddataelementocliente: equipo.iddataelementocliente,
                                idelemento: equipo.idelemento,
                                idseccion: equipo.idseccion,
                                otro: equipo.otro
                            })
                        } else {
                            equipoArea.push({
                                cantidad: equipo.cantidad,
                                descripcion: "",
                                capacidad: equipo.descripcion,
                                elemento: {
                                    idelemento: equipo.elemento.idelemento,
                                    nombreelemento: equipo.elemento.nombreelemento
                                },
                                idanexocliente: equipo.idanexocliente,
                                iddataelementocliente: equipo.iddataelementocliente,
                                idelemento: equipo.idelemento,
                                idseccion: equipo.idseccion,
                                otro: equipo.otro
                            })
                        }

                    })
                }
            } else {
                setEquipo(envasadoOtrosContext?.equipo)
                setIsContext(true)
            }
        }
    }, [todo])

    useEffect(() => {
        if (verdaderaInstalacion.idtipoanexo === 2) {
            let procesosAux = []
            procesos.forEach(element => {
                if (element.idseccion == 26) {
                    procesosAux.push(element)
                }
            })
            setProcesosArea(procesosAux)
        }
    }, [procesos])

    useEffect(() => {
        procesosArea
    }, [procesosArea])


    const handleModificar = () => {
        setEditarEquipo(!editarEquipo);
    }

    const handleOpenModalNuevoEquipo = () => {
        setOpenModalNuevoEquipo(true);
    }
    const handleCloseModalNuevoEquipo = () => {
        setOpenModalNuevoEquipo(false);
    }

    useEffect(() => {
        if (verdaderaInstalacion.idtipoanexo === 2) {
            if (otros != true) {
                if (areaEnvasadoContext !== null) {
                    setInitialValues({
                        ...initialValues,
                        equipo: equipoArea,
                        procesos: areaEnvasadoContext.procesos,
                        largo: areaEnvasadoContext.superficie?.data?.largo,
                        ancho: areaEnvasadoContext.superficie?.data?.ancho,
                        area: areaEnvasadoContext.superficie?.data?.area
                    })
                } else {
                    setInitialValues({
                        ...initialValues,
                        equipo: equipoArea,
                    })
                }
            } else {
                if (envasadoOtrosContext !== null) {
                    setInitialValues({
                        ...initialValues,
                        equipo: equipoArea,
                        procesos: envasadoOtrosContext.procesos,
                        largo: envasadoOtrosContext.superficie?.data?.largo,
                        ancho: envasadoOtrosContext.superficie?.data?.ancho,
                        area: envasadoOtrosContext.superficie?.data?.area
                    })
                } else {
                    setInitialValues({
                        ...initialValues,
                        equipo: equipoArea,
                    })
                }
            }
        }
        if (verdaderaInstalacion.idtipoanexo === 3) {
            if (idseccion === 5) {
                if (productoGranelContext !== null) {
                    setInitialValues({
                        ...initialValues,
                        equipo: equipoArea,
                        procesos: productoGranelContext.procesos,
                        largo: productoGranelContext.superficie?.data?.largo,
                        ancho: productoGranelContext.superficie?.data?.ancho,
                        area: productoGranelContext.superficie?.data?.area
                    })
                } else {
                    setInitialValues({
                        ...initialValues,
                        equipo: equipoArea,
                    })
                }
            }
            if (idseccion === 11) {
                if (productoTerminadoContext !== null) {
                    setInitialValues({
                        ...initialValues,
                        equipo: equipoArea,
                        procesos: productoTerminadoContext.procesos,
                        largo: productoTerminadoContext.superficie?.data?.largo,
                        ancho: productoTerminadoContext.superficie?.data?.ancho,
                        area: productoTerminadoContext.superficie?.data?.area
                    })
                } else {
                    setInitialValues({
                        ...initialValues,
                        equipo: equipoArea,
                    })
                }
            }
            if (idseccion === 12) {
                if (almacenMaduracionContext !== null) {
                    setInitialValues({
                        ...initialValues,
                        equipo: equipoArea,
                        procesos: almacenMaduracionContext.procesos,
                        largo: almacenMaduracionContext.superficie?.data?.largo,
                        ancho: almacenMaduracionContext.superficie?.data?.ancho,
                        area: almacenMaduracionContext.superficie?.data?.area
                    })
                } else {
                    setInitialValues({
                        ...initialValues,
                        equipo: equipoArea,
                    })
                }
            }
        }
    }, [equipoArea])

    const handleNuevoEquipo = (valores) => {

        let equipoSeleccionado = tipoequipo.filter((t) => valores.tipo == t.idelemento)

        setEquipo([...equipoArea, {
            cantidad: valores.cantidad,
            capacidad: valores.capacidad,
            condicion: valores.condicion,
            descripcion: valores.descripcion,
            elemento: {
                idelemento: valores.tipo,
                tipoOtros: valores.tipoOtros,
                nombreelemento: equipoSeleccionado[0].elemento.nombreelemento
            },
            //idanexocliente: 1,
            //iddataelemntocliente: 1,
            //idseccion: 1,
            otro: null
        }])

        handleCloseModalNuevoEquipo();
    }

    const handleEliminarEquipo = (elemento) => {
        let nuevoEquipo = equipoArea.filter((equipo) => equipo !== elemento);
        setEquipo(nuevoEquipo);
    }

    const modalNuevoEquipo = () => {
        return (
            <div>
                <Modal
                    open={openModalNuevoEquipo}
                    onClose={handleCloseModalNuevoEquipo}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <div style={{ textAlign: "center" }}>
                                Nuevo Equipo
                            </div>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <Formik
                                initialValues={informacionFormikModal}
                                onSubmit={(valores) => {
                                    handleNuevoEquipo(valores)
                                }}
                            >
                                {(props) => (
                                    <Form>
                                        <div className='table-responsive'>
                                            <table className='table table-striped table-hover'>
                                                <thead>
                                                    <tr>
                                                        <th>Tipo</th>
                                                        <th>Cantidad</th>
                                                        <th>Capacidad (ton)</th>
                                                        <th>Descripción y/o características</th>
                                                        <th width="120">Condición</th>
                                                        {
                                                            //<th>Largo (m)</th>
                                                            //<th>Ancho (m)</th>
                                                            //<th>Área (m²)</th>
                                                        }
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <Field
                                                                component="select"
                                                                id="tipo"
                                                                name="tipo"
                                                                className="form-select"
                                                                multiple={false}
                                                                required
                                                            >
                                                                <option defaultValue>Seleccione Tipo de Equipo</option>
                                                                {tipoequipo.map((t, index) => (
                                                                    <option key={index} value={t.idelemento}>{t.elemento.nombreelemento}</option>
                                                                ))}
                                                            </Field>

                                                            {
                                                                props.values.tipo === "4" ?
                                                                    <div>
                                                                        <br />
                                                                        <label htmlFor='tipoOtros'>Tipo de equipo:</label>
                                                                        <Field
                                                                            type="text"
                                                                            id="tipoOtros"
                                                                            name="tipoOtros"
                                                                            className="form-control form-control-sm"
                                                                        />
                                                                    </div>
                                                                    : <div></div>
                                                            }
                                                        </td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="cantidad" name="cantidad" placeholder="Cantidad" required /></td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="capacidad" name="capacidad" placeholder="Capacidad" required /></td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="descripcion" name="descripcion" placeholder="Descripción" required /></td>
                                                        <td>
                                                            <Field
                                                                component="select"
                                                                id="condicion"
                                                                name="condicion"
                                                                className="form-select"
                                                                multiple={false}
                                                                required

                                                            >
                                                                <option defaultValue>Seleccione Condicion</option>
                                                                <option value={"Buena"}>Buena</option>
                                                                <option value={"Regular"}>Regular</option>
                                                                <option value={"Mala"}>Mala</option>
                                                            </Field>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div style={{ textAlign: "center" }}>
                                            <button type='submit' className="btn btn-success">GUARDAR</button>
                                            <br />
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </Typography>
                        <br />

                    </Box>
                </Modal>
            </div>
        )
    }

    return (
        <Fragment>

            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validate={(valores) => {

                    if (verdaderaInstalacion.idtipoanexo === 2) {
                        if (otros != true) {
                            const sup = {
                                data: {
                                    largo: parseFloat(valores.largo),
                                    ancho: parseFloat(valores.ancho),
                                    area: parseFloat(valores.largo * valores.ancho),
                                    //idfi_25anexo: idanexo.idfi_25anexo,
                                    idseccion: 14,
                                }
                            }

                            const areaEnvasadoContext = {
                                superficie: sup,
                                equipo: valores.equipo,
                                procesos: valores.procesos,
                                procesosPreguntas: procesos,
                                //idfi_25anexo: idanexo.idfi_25anexo,
                                submit: false
                            }
                            setContextAreaEnvasado(areaEnvasadoContext)
                        } else {
                            const sup = {
                                data: {
                                    largo: parseFloat(valores.largo),
                                    ancho: parseFloat(valores.ancho),
                                    area: parseFloat(valores.largo * valores.ancho),
                                    //idfi_25anexo: idanexo.idfi_25anexo,
                                    idseccion: 14,
                                }
                            }

                            const envasadoOtrosContext = {
                                superficie: sup,
                                equipo: valores.equipo,
                                //idfi_25anexo: idanexo.idfi_25anexo,
                                submit: false
                            }
                            setContextEnvasadoOtros(envasadoOtrosContext)
                        }
                    } else if (verdaderaInstalacion.idtipoanexo === 3) {
                        if (idseccion === 5) {
                            const sup = {
                                data: {
                                    largo: parseFloat(valores.largo),
                                    ancho: parseFloat(valores.ancho),
                                    area: parseFloat(valores.largo * valores.ancho),
                                    //idfi_25anexo: idanexo.idfi_25anexo,
                                    idseccion: 5,
                                }
                            }

                            const productoGranelContext = {
                                superficie: sup,
                                equipo: valores.equipo,
                                //idfi_25anexo: idanexo.idfi_25anexo,
                                submit: false
                            }
                            setContextProductoGranel(productoGranelContext)
                        }
                        if (idseccion === 11) {
                            const sup = {
                                data: {
                                    largo: parseFloat(valores.largo),
                                    ancho: parseFloat(valores.ancho),
                                    area: parseFloat(valores.largo * valores.ancho),
                                    idfi_25anexo: idanexo.idfi_25anexo,
                                    idseccion: 11,
                                }
                            }

                            const productoTerminadoContext = {
                                superficie: sup,
                                equipo: valores.equipo,
                                idfi_25anexo: idanexo.idfi_25anexo,
                                submit: false
                            }
                            setContextProductoTerminado(productoTerminadoContext)
                        }
                        if (idseccion === 12) {
                            const sup = {
                                data: {
                                    largo: parseFloat(valores.largo),
                                    ancho: parseFloat(valores.ancho),
                                    area: parseFloat(valores.largo * valores.ancho),
                                    //idfi_25anexo: idanexo.idfi_25anexo,
                                    idseccion: 12,
                                }
                            }

                            const almacenMaduracionContext = {
                                superficie: sup,
                                equipo: valores.equipo,
                                //idfi_25anexo: idanexo.idfi_25anexo,
                                submit: false
                            }
                            setContextAlmacenMaduracion(almacenMaduracionContext)
                        }
                    }

                }}

                onSubmit={(valores) => {

                    try {

                        const sup = {
                            data: {
                                largo: parseFloat(valores.largo),
                                ancho: parseFloat(valores.ancho),
                                area: parseFloat(valores.largo * valores.ancho),
                                //idfi_25anexo: idanexo.idfi_25anexo,
                                idseccion: 14,
                            }
                        }

                        dispatch(insertSuperficie(sup))

                        if (valores.procesos.length > 0) {
                            procesos.map((p, index) => {

                                const data = {
                                    data: {
                                        //idfi_25anexo: idanexo.idfi_25anexo,
                                        comentarios: valores.procesos[index],
                                        idproceso: p.idproceso,
                                    }
                                }

                                dispatch(insertFi25Procesos(data))   //Anexo Up procesos

                            })
                        } else {
                            console.log("procesos vacio")
                        }

                        if (valores.equipo.length > 0) {
                            valores.equipo.map((e) => {

                                const equipoHistorial = {
                                    data: {
                                        idelemento: parseInt(e.elemento.idelemento),
                                        tipootros: e.elemento.tipoOtros,
                                        cantidad: parseInt(e.cantidad),
                                        capacidad: parseFloat(e.capacidad),
                                        descripcion: e.descripcion,
                                        condicion: e.condicion,
                                        verificado: true,
                                        //idfi_25anexo: idanexo.idfi_25anexo
                                    }
                                }

                                const dataElementoClienteHistorial = {
                                    data: {
                                        cantidad: parseInt(e.cantidad),
                                        descripcion: e.descripcion,
                                        otro: "",
                                        idelemento: parseInt(e.elemento.idelemento),
                                        tipootros: e.elemento.tipoOtros,
                                        idseccion: 1,
                                        iddataelementocliente: e.iddataelementocliente
                                    }
                                }

                                dispatch(insertEquipoHistorial(equipoHistorial))   //Equipo Historial
                                dispatch(insertDataElementoClienteHistorial(dataElementoClienteHistorial))   //Data Elemento Cliente Historial

                            })
                        } else {
                            console.log("vacio")
                        }

                        const areaEnvasadocontext = {
                            superficie: sup,
                            equipo: valores.equipo,
                            procesos: valores.procesos,
                            procesosPreguntas: procesosArea,
                            submit: true
                        }

                        setContextAreaEnvasado(areaEnvasadocontext)

                        Store.addNotification({
                            title: "Pesado de Maguey",
                            message: "Guardado exitosamente!",
                            type: "success",
                            insert: "center",
                            container: "top-center",
                            animationIn: ["animate__animated", "animate__fadeIn"],
                            animationOut: ["animate__animated", "animate__fadeOut"],
                            dismiss: {
                                duration: 3000,
                                onScreen: true
                            }
                        });

                    } catch (error) {
                        console.log(error)
                    }

                }}
            >
                {({ values }) => (
                    <Form>
                        {/* } <div className='row'>
                            <label className={`${estilos.labelUI_title} mb-2`}>PESADO DE AGAVE</label>
                        </div>
                        */}
                        <div className={`${estilos.labelUI} row mb-2`}>
                            <label className={`${estilos.labelUI} mb-2`}>Superficie:</label>
                        </div>
                        <div className='row'>
                            <div className="col-md-3 mb-3">
                            </div>
                            <div className="col-md-2 mb-3">
                                <label htmlFor="largo">Largo (m)</label>
                                <Field type="text" className="form-control form-control-sm" id="largo" name="largo" placeholder="Largo" required />
                            </div>
                            <div className="col-md-2 mb-3">
                                <label htmlFor="ancho">Ancho (m)</label>
                                <Field type="text" className="form-control form-control-sm" id="ancho" name="ancho" placeholder="Ancho" required />
                            </div>

                            <div className="col-md-2 mb-3">
                                <label htmlFor="area">Área (m²)</label>
                                <Field type="text" className="form-control form-control-sm" id="area" name="area" placeholder="Área" value={values.largo * values.ancho} required />
                            </div>
                        </div>
                        <hr />
                        <div className='table-responsive'>
                            <table className='table table-striped table-hover'>
                                <thead>
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Cantidad</th>
                                        <th>Capacidad (ton)</th>
                                        <th>Descripción y/o características</th>
                                        <th width="120">Condición</th>
                                        {
                                            //<th>Largo (m)</th>
                                            //<th>Ancho (m)</th>
                                            //<th>Área (m²)</th>
                                        }
                                        <th>Acciones</th>
                                        <th>Validar</th>
                                    </tr>
                                </thead>

                                <FieldArray
                                    name="equipo"
                                    render={arrayHelpers => (
                                        <tbody>
                                            {equipoArea &&
                                                equipoArea.map((equipo, index) => {
                                                    return (

                                                        <tr key={index}>
                                                            <td>
                                                                {equipo.elemento.nombreelemento}
                                                                <h6>{equipo.elemento.tipoOtros}</h6>
                                                                <h6>{equipo.otro}</h6>
                                                            </td>
                                                            <td><Field type="text" className="form-control form-control-sm" id="cantidad" name={`equipo.${index}.cantidad`} placeholder="Cantidad" disabled={editarEquipo} required /></td>
                                                            <td><Field type="text" className="form-control form-control-sm" id="capacidad" name={`equipo.${index}.capacidad`} placeholder="Capacidad" disabled={editarEquipo} required /></td>
                                                            <td><Field type="text" className="form-control form-control-sm" id="descripcion" name={`equipo.${index}.descripcion`} placeholder="Descripción" disabled={editarEquipo} required /></td>
                                                            <td>
                                                                <Field
                                                                    component="select"
                                                                    id="condicion"
                                                                    name={`equipo.${index}.condicion`}
                                                                    className="form-select"
                                                                    multiple={false}
                                                                    disabled={editarEquipo}
                                                                    required

                                                                >
                                                                    <option defaultValue>Seleccione Condicion</option>
                                                                    <option value={"Buena"}>Buena</option>
                                                                    <option value={"Regular"}>Regular</option>
                                                                    <option value={"Mala"}>Mala</option>
                                                                </Field>
                                                            </td>
                                                            {
                                                                //<td><Field type="text" className="form-control form-control-sm" id="largo" name={`equipo.${index}.largo`} placeholder="Largo" disabled={editarEquipo} required /></td>
                                                                //<td><Field type="text" className="form-control form-control-sm" id="ancho" name={`equipo.${index}.ancho`} placeholder="Ancho" disabled={editarEquipo} required /></td>
                                                                //<td><Field type="text" className="form-control form-control-sm" id="area" name={`equipo.${index}.area`} placeholder="Área" value={superficie.area} disabled={editarEquipo} required /></td>
                                                            }
                                                            <td><button type="button" className='btn btn-warning btn-sm' onClick={() => handleModificar()}>Modificar</button>
                                                                <hr />
                                                                <button className='btn btn-danger btn-sm' onClick={() => handleEliminarEquipo(equipo)}>Eliminar</button>
                                                            </td>
                                                            <td><Field className="form-check-input" type="checkbox" name={`equipo.${index}.validar`} id="validar" /></td>
                                                        </tr>
                                                    )
                                                }
                                                )}

                                        </tbody>
                                    )}
                                />
                            </table>
                        </div>
                        <br />
                        <div style={{ textAlign: "center" }}>
                            <button type="button" className={`btn ${estilos.botonCircular}`} onClick={handleOpenModalNuevoEquipo}>+ </button> Añadir nuevo equipo
                        </div>
                        <br />
                        <div className='row'>
                            <label className={`${estilos.labelUI} mb-2`}>MÉTODO</label>
                        </div>
                        <div className='row'>
                            <div className="col-md-4 mb-3">
                                <label htmlFor="">PROCESO</label>
                            </div>
                            <div className="col-md-8 mb-3">
                                <label htmlFor="">DESCRIPCIÓN</label>
                            </div>
                        </div>
                        {
                            verdaderaInstalacion.idtipoanexo === 2 ?
                                otros != true ?
                                    <FieldArray
                                        name='procesos'
                                        render={arrayHelpers => (
                                            <div>
                                                {procesosArea.map((p, index) => (
                                                    <div key={index}>
                                                        <div className='row'>
                                                            <div className="col-md-4 mb-3">
                                                                <label htmlFor={`proceso.${index}`}>{p.descripcion}</label>
                                                            </div>
                                                            <div className="col-md-8 mb-3">
                                                                <Field type="text" className="form-control form-control-sm" id={`procesos.${index}`} name={`procesos.${index}`} placeholder={p.descripcion} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    />
                                    :
                                    <div></div>
                                :
                                <div></div>

                        }
                        {
                            //<div className="row mb-5">
                            //    <div className="col ">
                            //        <button className={`btn ${estilos.botonVerdeCOMERCAM}`} type='submit'>GUARDAR</button>
                            //    </div>
                            //
                            //</div>
                        }
                    </Form>
                )}
            </Formik>
            <div>
                {modalNuevoEquipo()}
            </div>
        </Fragment>
    );
};


export default withRouter(ProcesosYEquipo)
